<procure-card class="card">
  <p class="text">
    {{ label() }}
  </p>
  @if (users().length) {
    <p class="text">For details, please reach out to:</p>
    <procure-tag-list
      class="users"
      linear
      [users]="users()"
      (selectActive)="copyEmail($event)"
    />
  }
  <div class="actions">
    <button
      class="button"
      procure-button
      [routerLink]="redirectUrl()"
    >
      {{ redirectLabel() }}
    </button>
  </div>
</procure-card>
